// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","accent":"#BFD730","primary":"#492172","mobileLinks":"Sbqs","show":"DQtg","mobileLink":"_2ROj","info":"_1hXM"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/MobileMenu/MobileMenu.scss
// module id = C/qL
// module chunks = 0